import { alertError, alertDelete, alertSuccess } from "@cems-eco/core/src/utils/widget";
import { MaintenanceIndexPage } from ".";
import storage from "@/storage";
import { ISiteStorage } from "@/storage/model";
import { Options } from "vue-class-component";
import components from "../../components/component";
import { ElLoading } from "element-plus";
import { Subscription } from "rxjs";
import moment from "moment";


@Options({
    components,
})
export class BoxMaintenancePage extends MaintenanceIndexPage {

    updateHeaders(): void {
        let auth = storage.getSync<any>(storage.AUTH);
        if (auth) {
            this.headers.Authorization = `Bearer ${auth["access_token"]}`;
        }
    }

    searching() {
        const loader = ElLoading.service({ lock: true });
        
        const searchUrl = this.maintenanceBloc.searchParams(this.maintenance);
        this.dt.ajax.url(searchUrl);
        this.dt.ajax.reload();

        loader.close();
    }

    async downloadData(data: any) {
        const loader = ElLoading.service({ lock: true });
        try {
            await this.maintenanceBloc.downloadFile('maintenance-file.pdf', data.id);
            loader.close();
        } catch (error) {
            alertError(error);
            loader.close();
        }
    }

    async deleteData(data: any) {
        alertDelete().then(async (result) => {
            try {
                if (!result.isConfirmed) {
                    alertSuccess('Deletion abort.', 'Your data is save.')
                    return;
                }
                let message = await this.maintenanceBloc.deleteRelation(data.id);
                alertSuccess('Good Job!', 'Your data has been deleted.');
                this.buildDataTable();
            } catch (error) {
                alertError(error);
            }
        })
    }

    async viewData(data: any) {
        this.$router.push(`/maintenance/${data.id}`);
    }

    async editData(data: any) {
        this.$router.push(`/maintenance/${data.id}/edit`);
    }
}

